export type UpdateTicketStatusMemoRequest = {
  pjtId: string;
  tcktTypeCd: string;
  tcktStsTypeCd: string;
  mmTxt: string;
  updateDateTime?: string;
};
